import { APP_SWITCHER_TARGET_ID } from '../constants';
export const getAppSwitcherDomTarget = (targetId) => {
    const domTarget = document.querySelector(`#${targetId || APP_SWITCHER_TARGET_ID}`);
    return domTarget;
};
export const positionMenuTargetFunc = (menuDomTarget, targetId) => () => {
    const domNodeTarget = getAppSwitcherDomTarget(targetId);
    const { top = 0, height, right = 0 } = domNodeTarget?.getBoundingClientRect() ?? {};
    if (!height) {
        return;
    }
    menuDomTarget.setAttribute('style', `top: ${top + height}px; left: ${right - 300}px;`);
};
